import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#383FFF",
      "fill-rule": "evenodd",
      d: "M6.957 10.121a1 1 0 1 1 1.414-1.414l3.586 3.586 3.586-3.586a1 1 0 1 1 1.414 1.414l-4.293 4.293a1 1 0 0 1-1.414 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2",
      height: "10",
      x: "11",
      y: "3",
      fill: "#383FFF",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#383FFF",
      "fill-rule": "evenodd",
      d: "M5 14a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }